import React,{useEffect,useState} from "react"
import api from "../api/api"
import { toast } from "react-toastify";

function InvoiceSettings(){

const [data,setData] = useState({
 invoicePrefix:"",
 invoiceStartNumber:"",
 footerText:"",
 showLogo:true
})

useEffect(()=>{
 loadInvoice()
},[])

const loadInvoice = async ()=>{
 try{
 const res = await api.get("/settings/invoice")
 if(res.data) setData(res.data)
 }catch(error){
 console.error("Invoice load error:",error)
 }
}

const handleChange=(e)=>{
 const {name,value,type,checked}=e.target
 setData({...data,[name]:type==="checkbox"?checked:value})
}

const handleSubmit=async(e)=>{
 e.preventDefault()

 try{
 await api.put("/settings/invoice",data)
 toast.success("Invoice settings updated ✅");
 
 }catch(error){
 console.error("Update error:",error)
 }
}

return(

<div className="container mt-4">

<div className="card shadow-sm">

<div className="card-header " style={{backgroundColor : "#BFC9D1"}}>
<h5 style={{lineHeight : "1.5", color : "white"}}>Invoice Settings</h5>
</div>

<div className="card-body">

<form onSubmit={handleSubmit}>

<div className="row">

<div className="col-md-6">
<label>Invoice Prefix</label>
<input name="invoicePrefix" value={data.invoicePrefix||""} onChange={handleChange} className="form-control"/>
</div>

<div className="col-md-6">
<label>Start Number</label>
<input name="invoiceStartNumber" value={data.invoiceStartNumber||""} onChange={handleChange} className="form-control"/>
</div>

<div className="col-md-12 mt-3">
<label>Footer Text</label>
<textarea name="footerText" value={data.footerText||""} onChange={handleChange} className="form-control"/>
</div>

<div className="col-md-12 mt-3">
<label>
<input type="checkbox" name="showLogo" checked={data.showLogo||false} onChange={handleChange}/>
 Show Logo on Invoice
</label>
</div>

</div>

<button className="btn btn-primary mt-4">
Save Settings
</button>

</form>

</div>

</div>

</div>

)

}

export default InvoiceSettings